import { coverageActions } from './';
import coverageServices from './services';
import i18n from 'i18nextInstance';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import { push } from 'react-router-redux';
import {
    call,
    put,
    takeEvery
} from 'redux-saga/effects';

function* _coverageDelete ({ payload }) {
    try {
        yield call(coverageServices.deleteCoverage, { id: payload });
        yield put(push(i18n.t('/coberturas/listar')));
    } catch (e) {}
}

function* _coverageRegistration ({ payload }) {
    try {
        yield put(coverageActions.setCoverageErrors({}));
        const { id, ...body } = payload;
        if (!id) {
            yield call(coverageServices.postCoverage, null, body);
        } else {
            yield call(coverageServices.putCoverage, { id }, body);
        }
        yield put(push(i18n.t('/coberturas/listar')));
    } catch ({ response: { data } }) {
        if (!isEmpty(data)) {
            const { api, cuit } = data;
            const newErrors = {
                ...(!isEmpty(api) && { api: i18n.t('Debe coincidir con una API integrada') }),
                ...(!isEmpty(cuit) && { cuit: i18n.t('Ya se encuentra utilizado') })
            };
            yield put(coverageActions.setCoverageErrors(newErrors));
        }
    }
}

function* _getCoverage ({ payload: id }) {
    try {
        yield put(coverageActions.setCoverageLoading(true));
        const { data } = yield call(coverageServices.getCoverage, { id });
        yield put(coverageActions.setCoverageSelected(data));
    } catch (e) {

    } finally {
        yield put(coverageActions.setCoverageLoading(false));
    }
}

function* _getCoverageListing ({ payload }) {
    try {
        yield put(coverageActions.setCoverageLoading(true));
        const { data } = yield call(coverageServices.getCoverageList, null, payload);
        yield put(coverageActions.setCoverageList(orderBy(data, [({ business_name }) => business_name.toLowerCase()], ['asc'])));
    } catch (e) {

    } finally {
        yield put(coverageActions.setCoverageLoading(false));
    }
}

export default [
    takeEvery(coverageActions.coverageDelete.type, _coverageDelete),
    takeEvery(coverageActions.coverageRegistration.type, _coverageRegistration),
    takeEvery(coverageActions.getCoverage.type, _getCoverage),
    takeEvery(coverageActions.getCoverageListing.type, _getCoverageListing)
];
